import '../../../design/introduction.css';
import { introductionGallery } from "../../../utils/functions/introductionGallery";
import teacherImage from "../../../assets/introduction/mainPageImage.avif";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";

export default function Introduction() {
    const navigate = useNavigate();
    const location = useLocation();

    const handleScrollTo = (anchor) => {
        if (location.pathname !== "/") {
            navigate("/", { replace: false });
            setTimeout(() => {
                document.querySelector(anchor)?.scrollIntoView({ behavior: "smooth" });
            }, 50);
        } else {
            document.querySelector(anchor)?.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <div className="intro">
            {/* Background Decorations */}
            <div className="intro-blob blob-top"></div>
            <div className="intro-blob blob-bottom"></div>

            {/* Logo Overlay */}
            <div className="logo">
                <motion.b
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.8, type: "spring" }}
                >
                    T<span>e</span>acheR<span>h</span>uB
                </motion.b>
            </div>

            <div className="intro-container">

                {/* Left Text */}
                <motion.div
                    className={'intro-left'}
                    initial={{ opacity: 0, x: -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.7 }}
                >
                    <h1 className="intro-title">
                        მასწავლებელს ეძებ? <span>✨</span>
                    </h1>

                    <p className="intro-subtitle">
                        აღმოაჩინე საუკეთესო მენტორები შენი შვილისთვის.
                        მარტივი ძიება გამოცდილების, ფასისა და მდებარეობის მიხედვით.
                    </p>

                    <div className="intro-buttons">
                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => navigate('/find-teacher')}
                            className="btn-primary"
                        >
                            მოძებნე მასწავლებელი
                        </motion.div>
                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => handleScrollTo("#aboutUs")}
                            className="btn-secondary"
                        >
                            როგორ მუშაობს
                        </motion.div>
                    </div>
                </motion.div>

                {/* Right Image */}
                <motion.div
                    className={'intro-right'}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    <div className="image-stack">
                        <div className="image-bg-circle"></div>
                        <img src={teacherImage} alt="Teacher"/>
                    </div>
                </motion.div>

            </div>

            {/* Features */}
            <div className="intro-features">
                {introductionGallery.map((item, index) => (
                    <motion.div
                        key={index}
                        className={`feature-card card-variant-${index % 3}`}
                        whileHover={{ y: -15 }}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.2 }}
                    >
                        <div className="feature-icon-wrapper">
                            <img src={item.image} alt={item.title}/>
                        </div>
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                    </motion.div>
                ))}
            </div>
        </div>
    );
}